module.exports = __webpack_public_path__ + "media/app/assets/specializations/demon_hunter/vengeance-4720ed57979cce2fb5c4f73e5e48b758.png";